import { capabilities } from 'navigation-components/capabilities';
import { useInvokeCapability } from 'navigation-components/consumer/hooks';
import { useEffect, useRef, useState } from 'react';
const useUpdateIframeDimensionsOnResize = ({
  containerRef,
  additionalHeightAdjustment = 0,
  additionalWidthAdjustment = 0
}) => {
  const [dimensions, setDimensionsState] = useState({
    height: 0,
    width: 0
  });
  const dimensionsRef = useRef(dimensions);
  const changeIframeStyle = useInvokeCapability(capabilities.RESTYLE_CAP);
  useEffect(() => {
    const floatingContainer = containerRef.current;
    if (!floatingContainer) return;
    const resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        const {
          height: refHeight,
          width: refWidth
        } = entry.contentRect;
        const adjustedWidth = refWidth ? refWidth + additionalWidthAdjustment : 0;
        const adjustedHeight = refHeight ? refHeight + additionalHeightAdjustment : 0;
        if (adjustedWidth !== dimensionsRef.current.width || adjustedHeight !== dimensionsRef.current.height) {
          dimensionsRef.current = {
            width: adjustedWidth,
            height: adjustedHeight
          };
          setDimensionsState(dimensionsRef.current);
          changeIframeStyle({
            style: {
              width: adjustedWidth,
              height: adjustedHeight
            },
            merge: true
          });
        }
      }
    });
    resizeObserver.observe(floatingContainer);
    return () => {
      if (floatingContainer) {
        resizeObserver.unobserve(floatingContainer);
      }
    };
  }, [additionalHeightAdjustment, additionalWidthAdjustment, changeIframeStyle, containerRef, dimensionsRef]);
  return dimensions;
};
export default useUpdateIframeDimensionsOnResize;